import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button/standard-button';
import CrossIcon from '@atlaskit/icon/glyph/cross';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { ModalTitle, ModalHeader } from '@atlaskit/modal-dialog';
import { Box, xcss } from '@atlaskit/primitives';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { useIntl } from '@atlassian/jira-intl';
import HelpIcon from '../../common/ui/help-icon';
import { FeedbackButton } from './feedback-button';
import messages from './messages';

type Props = {
	onClose: () => void;
};

const CloseButton = ({ onClose }: Props) => {
	const { formatMessage } = useIntl();
	return (
		<Button onClick={onClose} spacing="none" appearance="subtle">
			<CloseIconContainer>
				<CrossIcon label={formatMessage(messages.closeButtonLabel)} />
			</CloseIconContainer>
		</Button>
	);
};

const Header = ({ onClose }: Props) => {
	const { formatMessage } = useIntl();
	return (
		<ModalHeader>
			<LeftSection>
				<ModalTitle>{formatMessage(messages.title)}</ModalTitle>
				<Box xcss={helpIconWrapperStyles}>
					<HelpIcon message={formatMessage(messages.helpTooltip)} />
				</Box>
			</LeftSection>
			<RightSection>
				<Box xcss={feedbackButtonWrapperStyles}>
					<FeedbackButton />
				</Box>
				<CloseButton onClose={onClose} />
			</RightSection>
		</ModalHeader>
	);
};

export default Header;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LeftSection = styled.div({
	display: 'flex',
	alignItems: 'center',
});

const helpIconWrapperStyles = xcss({
	marginLeft: 'space.100',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const RightSection = styled.div({
	display: 'flex',
	alignItems: 'center',
});

const feedbackButtonWrapperStyles = xcss({
	marginRight: 'space.100',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CloseIconContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 4}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${gridSize * 4}px`,
});
